module.exports = __webpack_public_path__ + "static/media/The-Meadows-Amendment-4.75b577d6.pdf";